<template>
  <component
    :is="tag"
    class="card-standard--section"
    :class="sectionClasses"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { cx } from '@/helpers'

defineOptions({ name: 'CardSection' })
const props = defineProps({
  tag: { type: String, default: 'div' },
  horizontal: { type: Boolean, default: false }
})

const sectionClasses = computed(() => cx(
  props.horizontal && 'is-horizontal'
))
</script>
